import type { ChronologyVersion } from "../../types";
import type { VisitDisplay } from "../types";

// Keeps the provenance badge visible when the source version is deleted or versions are still loading.
const UNRESOLVED_SOURCE_VERSION_NAME = "another version";

/** Non-copied visits are returned by reference so their identity survives a versions refetch. */
export const withCopySourceVersionNames = (
  visits: VisitDisplay[],
  versions: ChronologyVersion[]
): VisitDisplay[] => {
  const versionNameById = new Map(versions.map((v) => [v.version_id, v.version_name]));
  return visits.map((visit) => {
    const sourceVersionName = visit.source_version_id
      ? (versionNameById.get(visit.source_version_id) ?? UNRESOLVED_SOURCE_VERSION_NAME)
      : undefined;
    if (sourceVersionName === visit.sourceVersionName) return visit;
    return { ...visit, sourceVersionName };
  });
};
